/* eslint-disable react/prop-types */
import { motion } from "framer-motion";

import { IMAGE_URL } from "../../../constants";
const FocusArea3 = ({ data }) => {
  return (
    <div className="grid grid-cols-1 py-20 md:grid-cols-2 lg:grid-cols-3">
      {/* First Column */}
      <div className="flex flex-col items-center justify-start gap-20">
        <motion.div
          initial={{
            y: "200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className=" space-y-4 overflow-hidden drop-shadow-lg text-center bg-gray-100 max-w-[300px] size-fit rounded-xl z-10"
        >
          <img
            className="object-cover w-fit h-fit "
            src={`${IMAGE_URL}/${data[0].image}`}
            alt=""
          />
          <div className="p-5 ">
            <h2 className="text-2xl font-medium">{data[0]?.title}</h2>
            <p>{data[0]?.description}</p>
          </div>
        </motion.div>
        <motion.div
          initial={{
            y: "-200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className="h-[300px] bg-[#910C28] w-[3px] z-0"
        ></motion.div>
      </div>

      {/* Second Column */}
      <div className="flex flex-col-reverse items-center justify-start gap-16 md:flex-col">
        <motion.div
          initial={{
            y: "200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className="h-[300px] bg-[#910C28] w-[3px] z-0"
        ></motion.div>
        <motion.div
          initial={{
            y: "200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className=" space-y-4 overflow-hidden drop-shadow-lg text-center bg-gray-100 max-w-[300px] size-fit rounded-xl z-10"
        >
          <img
            className="object-cover aspect-square max-h-52  w-full h-fit "
            src={`${IMAGE_URL}/${data[1].image}`}
            alt=""
          />
          <div className="p-5 ">
            <h2 className="text-2xl font-medium"> {data[1].title} </h2>
            <p>{data[1].description}</p>
          </div>
        </motion.div>
      </div>

      {/* Third Column */}
      <div className="flex flex-col items-center justify-start gap-20">
        <motion.div
          initial={{
            y: "200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className=" space-y-4 overflow-hidden drop-shadow-lg text-center bg-gray-100 max-w-[300px] size-fit rounded-xl z-10"
        >
          <img
            className="object-cover w-fit h-fit "
            src={`${IMAGE_URL}/${data[2].image}`}
            alt=""
          />
          <div className="p-5 ">
            <h2 className="text-2xl font-medium">{data[2].title} </h2>
            <p>{data[2].description}</p>
          </div>
        </motion.div>
        <motion.div
          initial={{
            y: "-200px",
          }}
          transition={{
            duration: 2,
          }}
          whileInView={{
            y: 0,
          }}
          className="h-[300px] hidden lg:block bg-[#910C28] w-[3px] z-0"
        ></motion.div>
      </div>
    </div>
  );
};

export default FocusArea3;
